import { reactive, toRefs, nextTick } from 'vue'
import { clone } from '@/common/js/just'
import { getSysTagByTree } from '@/api/common.model.js'
export const useAiKeywords = (auditForm, emits) => {
  const keywordModel = reactive({
    keywordInputValue: '',
    aiKeywordAddInputVisible: false,
    keywordAddInputRef: null
  })

  function showAddInput() {
    keywordModel.aiKeywordAddInputVisible = true
    nextTick(() => {
      keywordModel.keywordAddInputRef.focus()
    })
  }
  function onAddInputConfirm() {
    if (keywordModel.keywordInputValue) {
      auditForm.value.analysisTaskResult.keywords.push(keywordModel.keywordInputValue)
    }
    keywordModel.aiKeywordAddInputVisible = false
    keywordModel.keywordInputValue = ''
    emits('update:modified', true)
  }

  function onKeywordRemove(index) {
    auditForm.value.analysisTaskResult.keywords.splice(index, 1)
    emits('update:modified', true)
  }

  return {
    ...toRefs(keywordModel),
    showAddInput,
    onKeywordRemove,
    onAddInputConfirm
  }
}

export const useAiTags = (auditForm, emits) => {
  const tagModel = reactive({
    aiTagCascaderRef: null,
    aiTagAddModalVisible: false,
    modalKeywords: '',
    cascaderOpts: [],
    aiTagsTreeList: [],
    seletedAiTags: [],
    selectedNodes: []
  })

  // 根据modalKeywords在options源数据中递归搜索，返回树形结构结果
  const onSearchboxInput = () => {
    // 清空现有结果
    tagModel.cascaderOpts = []

    if (!tagModel.modalKeywords.trim()) {
      tagModel.cascaderOpts = clone(tagModel.aiTagsTreeList)
      return
    }

    // 递归搜索函数
    const searchInTree = (nodes) => {
      const results = []

      for (const node of nodes) {
        // 创建节点副本
        const newNode = { ...node }

        // 检查当前节点是否匹配关键词
        const isMatch = node.content.toLowerCase().includes(tagModel.modalKeywords.toLowerCase())

        if (node.children) {
          // 递归搜索子节点
          const childrenResults = searchInTree(node.children)
          if (childrenResults.length > 0) {
            newNode.children = childrenResults
            results.push(newNode)
          } else if (isMatch) {
            // 如果当前节点匹配且没有匹配的子节点，保留完整的子节点结构
            newNode.children = node.children
            results.push(newNode)
          }
        } else if (isMatch) {
          // 叶子节点匹配则直接添加
          results.push(newNode)
        }
      }

      return results
    }

    // 执行搜索并更新结果
    const searchResults = searchInTree(tagModel.aiTagsTreeList)
    tagModel.cascaderOpts.push(...searchResults)
  }

  function getModalTreeData() {
    getSysTagByTree({ labelType: 5, mgameId: auditForm.value.mgameId }).then((data) => {
      tagModel.aiTagsTreeList = data
      tagModel.cascaderOpts = data
    })
  }

  function onAiTagAdd() {
    tagModel.aiTagAddModalVisible = true
    getModalTreeData()
  }

  function onTagRemove(index) {
    const suggestedTags = auditForm.value.analysisTaskResult.suggested_tags

    suggestedTags.splice(index, 1)

    auditForm.value = {
      ...auditForm.value,
      analysisTaskResult: {
        ...auditForm.value.analysisTaskResult,
        suggested_tags: suggestedTags
      }
    }
    emits('update:modified', true)
  }

  function onAiTagSelectChange() {
    const nodes = tagModel.aiTagCascaderRef.getCheckedNodes()
    tagModel.selectedNodes = nodes.map(node => ({ value: node.value, label: node.label, desc: node.data.labelDesc, labelPaths: node.pathLabels.join('/') }))
  }

  function onAiTagModalClose() {
    tagModel.aiTagAddModalVisible = false
    tagModel.seletedAiTags = []
    tagModel.selectedNodes = []
  }

  function onAitagModalConfirm() {
    const tags = tagModel.selectedNodes.map(node => ({ name: node.labelPaths, id: node.value, description: node.desc }))
    if (tags?.length) {
      // 排除已存在的id
      const existingIds = auditForm.value.analysisTaskResult.suggested_tags.map(tag => tag.id)
      const filteredTags = tags.filter(tag => !existingIds.includes(tag.id)).map(tag => {
        // 只显示最后一个标签
        const [lastTag] = tag.name.split('/').slice(-1) || []
        // 手动添加的标签，转换成与ai生成的标签一致的格式
        return { ...tag, name: tag.name.replace(/\//g, '\\'), lastTag: lastTag || '-' }
      })
      auditForm.value.analysisTaskResult.suggested_tags.push(...filteredTags)
      emits('update:modified', true)
    }
    onAiTagModalClose()
  }

  return {
    ...toRefs(tagModel),
    onSearchboxInput,
    onAiTagAdd,
    onTagRemove,
    onAiTagModalClose,
    onAiTagSelectChange,
    onAitagModalConfirm
  }
}

export const useSubtitles = () => {
  const subtitleModel = reactive({
    subtitleList: []
  })

  function onSubtitleEdit() {
    if (subtitleModel.videoRef) {
      subtitleModel.videoRef.pause()
    }
  }

  return {
    ...toRefs(subtitleModel),
    onSubtitleEdit
  }
}
